import { render, staticRenderFns } from "./IsVimeoCustomer.vue?vue&type=template&id=b3a4a9b6&scoped=true&"
import script from "./IsVimeoCustomer.vue?vue&type=script&lang=js&"
export * from "./IsVimeoCustomer.vue?vue&type=script&lang=js&"
import style0 from "./IsVimeoCustomer.vue?vue&type=style&index=0&id=b3a4a9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a4a9b6",
  null
  
)

export default component.exports